export const formateDecimalNumber = (number: number) => {
  const formatedNumber: string = `${number.toLocaleString('hr-HR', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  })}`;
  return formatedNumber;
};
